export default "__VITE_ASSET__DuXjUoMc__"